<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="治疗师：" prop="keyword">
            <el-input v-model="query.keyword" placeholder="请输入手机号" size="small" />
          </el-form-item>
          <el-form-item label="治疗师身份：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
              <el-option label="研修班" :value="6"></el-option>
              <el-option label="体验班" :value="7"></el-option>
              <!-- <el-option v-for="(item,index) in identityOptions" :key="index" :label="item.name" :value="item.id"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="档案信息：" prop="keyword2">
            <el-input v-model="query.keyword2" placeholder="请输入手机号" size="small" />
          </el-form-item>
          <el-form-item label="治疗状态：">
            <el-select v-model="query.therapyStatus" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="治疗中" :value="0"></el-option>
              <el-option label="治疗结束" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="timeFilter" placeholder="请选择" clearable size="small">
              <el-option label="建档时间" :value="1"></el-option>
              <el-option label="最新复诊时间" :value="2"></el-option>
              <el-option label="下次复诊时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="治疗师" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            <span v-if="row.customerId">{{row.customerName}}{{row.customerLevel?'('+row.customerLevel+')':''}}<br />{{row.customerPho}}</span>
            <span v-if="row.techInfoId && !row.customerId">{{row.techInfoName}}{{row.techInfoLevel?'('+row.techInfoLevel+')':''}}<br />{{row.techInfoPho}}</span>
            
          </template>
        </el-table-column>
        <el-table-column label="档案信息" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            {{row.name}}<br />{{row.pho}}
          </template>
        </el-table-column>
        <el-table-column label="治疗次数" prop="therapyNum" align="center" />
        <el-table-column label="治疗时长(天)" prop="therapyDuration" align="center" />
        <el-table-column label="治疗状态" prop="timeLimit" align="center">
          <template slot-scope="{row}">
            {{row.therapyStatus === 0?'治疗中':'治疗结束'}}
          </template>
        </el-table-column>
        <el-table-column label="建档时间" prop="createdTime" align="center" />
        <el-table-column label="最新复诊时间" prop="operatedTime" align="center" />
        <el-table-column label="下次复诊时间" prop="subsequentVisitTime" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="130">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import patientApi from '@/api/archives/patient'
import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      selectItems: [],
      dateTime: null,
      identityOptions: [],
      timeFilter: undefined,
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    // this.getIdentity()
  },
  methods: {
    getIdentity() {
      customerLevelApi.fetchList({ isEnable: true }).then((res) => {
        this.identityOptions = res.data
      })
    },
    handleFilter() {
      this.timeFilter = undefined
      this.query = {}
      this.dateTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    resetTime() {
      this.query.startTime = undefined
      this.query.endTime = undefined
      this.query.nextStartTime = undefined
      this.query.nextEndTime = undefined
      this.query.newStartTime = undefined
      this.query.newEndTime = undefined
    },
    calcQuery() {
      this.resetTime()
      if (this.dateTime && this.dateTime.length > 0) {
        if (this.timeFilter === 1) {
          this.query.startTime = this.dateTime[0]
          this.query.endTime = this.dateTime[1]
        } else if (this.timeFilter === 2) {
          this.query.newStartTime = this.dateTime[0]
          this.query.newEndTime = this.dateTime[1]
        } else if (this.timeFilter === 3) {
          this.query.nextStartTime = this.dateTime[0]
          this.query.nextEndTime = this.dateTime[1]
        }
      }
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      let query = { ...this.query }
      this.listLoading = true
      return patientApi.fetchList(query)
        .then(( data ) => {
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => patientApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm(`当前选择${this.selectItems.length}条数据，是否确认删除`)
        .then(() => patientApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
  }
}
</script>
